(function () {
    angular
        .module('app')
        .controller('VersionEditorController', VersionEditorController);

    // Define controller dependencies.
    VersionEditorController.$inject = ['$q', '$rootScope', '$scope', 'Restangular', 'SanitizerFactory'];

    /**
     * Controller for 'editor' view of 'master.version' state.
     *
     * @param $q
     * @param $rootScope
     * @param $scope
     * @param Restangular
     * @param SanitizerFactory
     * @constructor
     */
    function VersionEditorController($q, $rootScope, $scope, Restangular, SanitizerFactory) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * Bindable properties.
         */
        vm.applicationValues = undefined;

        /**
         * Bindable methods.
         */
        vm.setApplicationValues = setApplicationValues;

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * Initialize editor's data source.
         *
         * @returns Promise
         */
        function initialize() {
            $scope.shared.editor.initialized = false;

            vm.applicationValues = undefined;

            return $q.when()
                .then(function () {
                    $scope.shared.editor.initialized = true;
                })
                .catch(function () {
                    return $q.reject();
                });

            function getResourceFieldValues(field) {
                return _.get(_.find($rootScope.global.resourceFields.version, {'name': field}), 'values');
            }
        }

        /**
         * Set default value for new resource.
         */
        function setNew() {
            if ($scope.shared.editor.initialized) {
                $scope.shared.editor.entity = {
                    id: undefined,
                    application_id: '',
                    version: '',
                    log: ''
                };
            }
        }

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * Set application values.
         */
        function setApplicationValues() {
            vm.applicationValues = undefined;
            return Restangular.all('application').getList({q: {
                s: [{f: 'id'}, {f: 'code'}],
                o: [{f: 'code', o: 'asc'}]
            }})
                .then(function (result) {
                    vm.applicationValues = SanitizerFactory.sanitizeReceived(result.original);
                });
        }

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            $scope.shared.editor.initialize = initialize;
            $scope.shared.editor.setNew = setNew;

            $scope.$on('CRUDFactory.editSuccess', function (event, entity) {
                vm.applicationValues = [entity.application];
            });
        }

        activate();
    }
})();
